/**
 * Узел-джанкшен: AndJunction или OrJunction (круг 20×20).
 */
import ArchimateNodeType from '../ArchimateNodeType';
import {AND_JUNCTION, OR_JUNCTION} from '../../util/ModelUtil';

const SIZE = {width: 20, height: 20};

export class AndJunctionNodeType extends ArchimateNodeType {
	static get typeName() {
		return AND_JUNCTION;
	}

	get shapeId() {
		return 'archimate:and-junction';
	}

	get defaultSize() {
		return SIZE;
	}

	canConnectTo() {
		return true;
	}

	getAllowedRelationshipTypes() {
		return [];
	}

	get canBeParent() {
		return false;
	}

	buildNodeConfig(pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor} = options;
		const w = width ?? SIZE.width;
		const h = height ?? SIZE.height;
		const nodeAttrs = {
			body: {
				fill: fillColor ?? '#000000',
				stroke: lineColor ?? '#000000',
				strokeWidth: 1,
			},
			label: {text: label ?? ''},
		};
		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
		};
	}
}

export class OrJunctionNodeType extends ArchimateNodeType {
	static get typeName() {
		return OR_JUNCTION;
	}

	get shapeId() {
		return 'archimate:or-junction';
	}

	get defaultSize() {
		return SIZE;
	}

	canConnectTo() {
		return true;
	}

	getAllowedRelationshipTypes() {
		return [];
	}

	get canBeParent() {
		return false;
	}

	buildNodeConfig(pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor} = options;
		const w = width ?? SIZE.width;
		const h = height ?? SIZE.height;
		const nodeAttrs = {
			body: {
				fill: fillColor ?? 'none',
				stroke: lineColor ?? '#000000',
				strokeWidth: 1,
			},
			label: {text: label ?? ''},
		};
		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
		};
	}
}
